export default {
  REMOTE: 'Remote',
  IN_OFFICE: 'In-Office',
  COWORKING: 'Coworking',
  ABSENT: 'Absent',
  WORK_MODE: 'Work mode',
  ERROR_ADD_ON_DAY_OFF: "Can't add a work mode on a day off",
  CALENDAR_NOTES:
    'Click on a work mode badge to change it, or add a new one by clicking on an empty date.',
  LOCKED_TITLE: 'Modification locked',
  LOCKED_MESSAGE: 'Modifications are locked',
  LOCK_SUCCESS: 'Lock activated successfully',
  UNLOCK_SUCCESS: 'Lock deactivated successfully',
  LOCK_ERROR: 'Error while modifying the lock',
  LOCK_BUTTON_TOOLTIP: 'Click to {state} the lock',
  LOCKED_STATE: 'locked',
  UNLOCKED_STATE: 'unlocked',
  CALENDAR_BUTTON: 'Calendar',
  LOCK_TOOLTIP: 'With the activation of this button, the collaborator cannot modify his presence and absence days from his profile.',
  UNLOCK_TOOLTIP: 'With the activation of this button, the collaborator can modify his presence and absence days from his profile.',
  LOCKED_BY_MESSAGE: 'Calendar locked',
  LOCKED_MODE_TOOLTIP: 'Work mode locked - contact an administrator to modify',
  UPDATE_SUCCESS: 'Work mode updated successfully',
  UPDATE_ERROR: 'Error updating work mode',
  ERROR_CHECKING_LOCK: 'Error checking lock status',
  USER_NOT_FOUND: 'User not found',
  ADMIN_ONLY: 'Only administrators can modify the lock status',
  ERROR_FETCHING_DATA: 'Error retrieving work modes',
  ERROR_FETCHING_DAYS_OFF: 'Error retrieving days off',
  VIEW_ONLY_MODE: 'View-only mode - You cannot modify this calendar',
  SCHEDULE: 'Usual work hours'
}
